<template>
    <div>
        <div class="flex items-center justify-center">
            <div class="w-full max-w-sm">
                <form class="bg-white shadow-md rounded px-8 pt-6 pb-8" @submit.prevent="submit">
                    <h2 class="text-2xl mb-1">
                        {{$t('Change Password')}}
                    </h2>
                    <div class="mb-4">
                        <JetLabel for="currentPassword" :value="$t('Current Password')"></JetLabel>
                        <JetInput id="currentPassword" v-model="form.current_password" :placeholder="$t('Current Password')" type="password"/>
                        <JetInputError :message="errors.current_password" class="mt-2"/>
                    </div>
                    <div class="mb-4">
                        <JetLabel for="newPassword" :value="$t('New Password')"></JetLabel>
                        <JetInput id="newPassword" v-model="form.password" :placeholder="$t('New Password')" type="password"/>
                        <JetInputError :message="errors.password" class="mt-2"/>
                    </div>
                    <div class="mb-4">
                        <JetLabel for="confirmPassword" :value="$t('New Password Confirmation')"></JetLabel>
                        <JetInput id="confirmPassword" v-model="form.password_confirmation" :placeholder="$t('New Password Confirmation')" type="password"/>
                        <JetInputError :message="errors.password_confirmation" class="mt-2"/>
                    </div>
                    <div class="flex items-center justify-between">
                        <JetButton type="submit" :processing="form.processing">
                            {{$t('Change Password')}}
                        </JetButton>
                    </div>
                </form>

            </div>
        </div>
    </div>
</template>

<script>
import JetButton from '@/Jetstream/Button'
import JetFormSection from '@/Jetstream/FormSection'
import JetInput from '@/Jetstream/Input'
import JetInputError from '@/Jetstream/InputError'
import JetLabel from '@/Jetstream/Label'

export default {
    name: 'ChangePassword',
    components: {JetButton, JetFormSection, JetInput, JetInputError, JetLabel},
    props: ['errors'],
    metaInfo() {
        return {
            title: this.title
        }
    },
    computed: {
        title () {
            return this.$t('Change Password');
        }
    },
    data() {
        return {
            form: {
                current_password: '',
                password: '',
                password_confirmation: '',
                processing: false
            },
        }
    },
    methods: {
        async submit() {
            this.processing = true;
            await this.$inertia.post(route('user.requestChangePassword').url(), this.form);
            this.processing = false;
        },
    }
}
</script>
